import React from 'react';

const PetActivityTimeline = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch(type) {
      case 'walk': return 'M9 5l7 7-7 7';
      case 'food': return 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z';
      case 'medical': return 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10';
      default: return 'M13 10V3L4 14h7v7l9-11h-7z';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h3 className="text-lg font-semibold mb-4">Actividades Recientes</h3>
      {activities.length > 0 ? (
        <div className="space-y-4">
          {activities.map(activity => (
            <div key={activity.id} className="flex items-start">
              <div className="bg-cyan-100 p-2 rounded-lg mr-4">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 text-cyan-600" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getActivityIcon(activity.type)} />
                </svg>
              </div>
              <div className="flex-1">
                <div className="flex justify-between">
                  <h4 className="font-medium capitalize">{activity.type}</h4>
                  <span className="text-sm text-gray-500">{activity.date} {activity.time}</span>
                </div>
                <p className="text-gray-600 mt-1">{activity.notes}</p>
                {activity.status === 'completed' && (
                  <span className="inline-block mt-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
                    Completado
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No hay actividades registradas</p>
      )}
    </div>
  );
};

export default PetActivityTimeline;